import { useState, useEffect } from "react";
import { workshopApi } from "../../../services/workshopApi";

/**
 * Custom hook to fetch global workshop statistics
 *
 * @returns {Object} { stats, loading, error, refetch }
 */
function useWorkshopStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStats = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await workshopApi.getWorkshopStats();

      if (response.success) {
        setStats(response.data.stats || null);
      } else {
        setError(
          new Error(response.message || "Failed to fetch workshop stats")
        );
      }
    } catch (err) {
      setError(err);
// Fallback stats in case of error (for development)
      setStats({
        totalWorkshops: 0,
        publishedWorkshops: 0,
        ongoingWorkshops: 0,
        completedWorkshops: 0,
        totalParticipants: 0,
        paidWorkshops: 0,
        freeWorkshops: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return {
    stats,
    loading,
    error,
    refetch: fetchStats,
  };
}

export default useWorkshopStats;
